// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--2OsyO";
export const content = "footer-module--content--3gJBi";
export const logo = "footer-module--logo--HA7UK";
export const image = "footer-module--image--t04FS";
export const nav = "footer-module--nav--2d_CA";